import { createSlice } from '@reduxjs/toolkit';

const initialState = { 
    byId: { }, 
    allIds: [],
    activeTabId: null
};

const dashboardTab = createSlice({
    name: 'dashboardTab',
    initialState: initialState,
    reducers: {
        setDashboardTabs(state, action) {
            const byId = action.payload.Tabs.reduce((byId, tab) => {
                byId[tab.TabKey] = tab;
                return byId;
            }, {});
            const allIds = Object.keys(byId);
            state.byId = byId;
            state.allIds = allIds
            state.activeTabId = state.activeTabId || allIds[0];
        },
        setActiveTab(state, action) { 
            if (state.allIds.indexOf(action.payload) !== -1) {
                state.activeTabId = action.payload;
            }
        }
    }
});

export const { name, actions, reducer } = dashboardTab;